import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_item = _resolveComponent("file-item")!
  const _component_uploading_file_item = _resolveComponent("uploading-file-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_select_file_item = _resolveComponent("select-file-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createBlock(_component_q_list, _mergeProps({ separator: _ctx.separator }, _ctx.$attrs), {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
        return (_openBlock(), _createBlock(_component_file_item, {
          key: file.url,
          file: file,
          "can-delete": _ctx.canDelete,
          onDeleted: ($event: any) => (_ctx.remove(file))
        }, null, 8, ["file", "can-delete", "onDeleted"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploading, (file) => {
        return (_openBlock(), _createBlock(_component_uploading_file_item, {
          key: file.name,
          file: file,
          onUploaded: _ctx.onUpload
        }, null, 8, ["file", "onUploaded"]))
      }), 128)),
      _withDirectives(_createVNode(_component_q_separator, null, null, 512), [
        [_vShow, _ctx.canUpload && _ctx.separator && _ctx.files.length > 0]
      ]),
      _withDirectives(_createVNode(_component_select_file_item, {
        placeholder: _ctx.uploadPlaceholder,
        "allowed-extensions": _ctx.allowedExtensions,
        onSelected: _ctx.upload
      }, null, 8, ["placeholder", "allowed-extensions", "onSelected"]), [
        [_vShow, _ctx.canUpload && (!this.maxFiles || (this.totalFiles < this.maxFiles))]
      ])
    ]),
    _: 1
  }, 16, ["separator"]))
}